export const PAGE_SIZE = 20
export const DATE_FORMAT = 'YYYY-MM-DD'
export const DEFAULT_ORDER_STATES = ['payment', 'complete']
export const ORDER_STATES = [
  'cart',
  'address',
  'requesting_quotation',
  'waiting_for_supplier',
  'waiting_customer_confirm',
  'deposit',
  'payment',
  'complete',
  'full_transferring_back',
  'cancel'
]
export const SORTS = ['latest_updated', 'latest_sent']
